<template>
    <div class="inner-modal inner-modal--af">
        <div class="inner-modal--header">
            <font-awesome-icon :icon="['fasl', 'fa-filter']" class="inner-modal--header--icon"> </font-awesome-icon>
            <h4>Advanced Filters</h4>
        </div>
        <div class="inner-modal--form">
            <div class="row" v-if="!filterProps.loading">
                <div v-for="(filter, index) in filterProps.filterOptions" :key="index" class="col-sm-12 col-md-4 col-lg-4 p-3">
                    <component :is="filter.displayType" v-bind="filter" :isSmallLabel="false" :showNumResults="true" :key="filter.slug" @filterChange="handleUpdateFilters" />
                </div>
            </div>
            <div v-else class="inner-modal--af--loading text-center">
                <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
                <h3 class="mt-3">Loading filters..</h3>
            </div>
        </div>
        <div v-if="!filterProps.loading" class="inner-modal--done">
            <Cta type="outline" size="lg" label="Done" @onClick="closeModal" />
        </div>
        <button @click="closeModal" class="inner-modal__close">&times;</button>
    </div>
</template>

<script lang="ts">
import { reactive } from 'vue';

import { useStore } from 'vuex';
import SearchInput from '../SearchInput.vue';
import Checkbox from '../Checkbox.vue'; // Adjust the path accordingly
import Radio from '../Radio.vue'; // Adjust the path accordingly
import Dropdown from '../Dropdown.vue';
import Cta from '../Cta.vue';
export default {
    name: 'AdvancedFiltersModal',
    setup() {
        const store = useStore();

        const filterProps = reactive({
            filterOptions: [],
            loading: true,
        });

        async function getOptions() {
            const filterOptions = await store.dispatch('fetchAdvancedFilters');

            filterProps.filterOptions = [...filterOptions.filters];
            filterProps.loading = false;
        }
        getOptions();
        async function handleUpdateFilters(filter) {
            const filterOptions = await store.dispatch('updateAdvancedFilters', filter);
            filterProps.filterOptions = [...filterOptions.filters];
        }
        const closeModal = async() => {
            await store.dispatch('closeModal');
        };
        return {
            store,
            filterProps,
            handleUpdateFilters,
            closeModal,
        };
    },
    components: {
        SearchInput,
        Checkbox,
        Radio,
        Dropdown,
        Cta,
    },
};
</script>
